import { Skeleton } from "@/components/skeleton";
import { Button } from "@stone-payments/jade";

type Props = {
  onClick?: () => void;
  loading?: boolean;
};

export const WhatsappShareButton = ({ onClick, loading = true }: Props) => {
  if (loading) return <Skeleton height="h-12" width="w-full" />;

  return (
    <Button
      icon="brand-whatsapp"
      onClick={onClick}
      size="medium"
      variant="primary-solid"
      className="flex-[1 1 auto] lg:flex-1"
      data-testid="product-whatsapp-button"
    >
      Peça pelo WhatsApp
    </Button>
  );
};
